export const LandingSponsorBanner = ({ banners, sponsorIndex, setSponsorIndex }) => {
  if (banners.length === 0) return null;

  return (
    <section className="py-3 sm:py-4" data-testid="sponsor-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-[10px] sm:text-xs text-slate-500 uppercase tracking-wider mb-1.5 font-semibold">Patrocinador</p>
        <div className="relative">
          <a href={banners[sponsorIndex].url} target="_blank" rel="noopener noreferrer"
            className="block rounded-lg sm:rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all"
            data-testid="sponsor-link">
            {banners[sponsorIndex].image_url ? (
              <div className="relative w-full aspect-[3/1] sm:aspect-[4/1] md:aspect-[5/1]">
                <img src={banners[sponsorIndex].image_url} alt={banners[sponsorIndex].title} className="w-full h-full object-cover" />
              </div>
            ) : (
              <div className="bg-gradient-to-r from-blue-600 to-blue-500 p-4 sm:p-6 md:p-8 text-center">
                <h3 className="text-lg sm:text-xl md:text-2xl font-black text-white mb-1">{banners[sponsorIndex].title}</h3>
                {banners[sponsorIndex].description && <p className="text-sm text-white/80">{banners[sponsorIndex].description}</p>}
              </div>
            )}
          </a>
          {banners[sponsorIndex].description && (
            <p className="text-xs text-slate-500 mt-1.5">{banners[sponsorIndex].description}</p>
          )}
          <div className="flex justify-center gap-2 mt-2">
            {banners.map((_, i) => (
              <button key={`sponsor-dot-${i}`} onClick={() => setSponsorIndex(i)}
                className={`w-2.5 h-2.5 rounded-full transition-all ${i === sponsorIndex ? 'bg-slate-700 w-6' : 'bg-slate-300'}`}
                data-testid={`sponsor-dot-${i}`} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
